import { cn } from '@/lib/utils'

/** The Adfusion console's mark: a profit-and-loss line across the middle, a
 *  thick bar rising above it on the left (revenue) and a thin one hanging
 *  below it on the right (spend). One colour: the square takes the text
 *  colour and the line and bars are cut out of it in the page colour, so it is
 *  dark on the light theme and light on the dark one. `public/favicon.svg` is
 *  the same drawing. */
export function BrandMark({ size = 22, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden className={cn('shrink-0', className)}>
      <rect width="24" height="24" rx="6.5" className="fill-foreground" />
      <rect x="4.5" y="11.2" width="15" height="1.6" rx="0.8" className="fill-background" />
      <rect x="6.4" y="5" width="4.6" height="7" rx="1.2" className="fill-background" />
      <rect x="14.2" y="12" width="2.6" height="6.4" rx="1" className="fill-background" />
    </svg>
  )
}

/** Mark and name together: the sidebar head and the sign-in page. */
export function Wordmark({ size = 22, className }: { size?: number; className?: string }) {
  return (
    <span className={cn('inline-flex min-w-0 items-center gap-2', className)}>
      <BrandMark size={size} />
      <span className="flex min-w-0 items-baseline gap-1.5">
        <span className="text-[15px] font-bold leading-none">Adfusion</span>
        <span className="truncate text-meta leading-none text-muted-foreground">콘솔</span>
      </span>
    </span>
  )
}
